import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';

export interface ScriptModel {
  name: string;
  src: string;
  loaded: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  private scripts: Array<ScriptModel> = [];

  load(script: ScriptModel): Observable<ScriptModel> {
    return new Observable<ScriptModel>((observer: Observer<ScriptModel>) => {
      const existingScript = this.scripts.find(s => s.name === script.name);

      if (existingScript && existingScript.loaded) {
        observer.next(existingScript);
        observer.complete();
      } else {
        this.scripts.push(script);

        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.src = script.src;

        scriptElement.onload = () => {
          script.loaded = true;
          observer.next(script);
          observer.complete();
        };

        scriptElement.onerror = (error: any) => {
          observer.error('Couldn\'t load script ' + script.src + ': ' + error.toString());
        };

        document.getElementsByTagName('body')[0].appendChild(scriptElement);
      }
    });
  }

  addScript(scriptContent: string): void {
    const scriptElement = document.createElement('script');
    scriptElement.innerHTML = scriptContent;
    document.getElementsByTagName('body')[0].appendChild(scriptElement)
  }
}
